module.exports = __webpack_public_path__ + "static/media/54.8d405c57.jpg";